import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-close",
  "use": "oc-close-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-close\"><path data-follow-fill=\"#696F7C\" fill=\"#696F7C\" d=\"m5.954 9.984-2.544 3.01 2.543 3.02 1.53-1.287-.61-.727H20.59v-2H6.868l.614-.725-1.528-1.291ZM5.59 5.5v2h15v-2h-15Zm0 13v2h15v-2h-15Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol